<script>
import { onMount, onDestroy, getContext } from 'svelte';
import Icon from 'svelte-icon';
import undoIcon from './undo-icon.svg';
import SplitPane from './SplitPane.svelte';
import CodeMirror from './CodeMirror.svelte';
import Instructions from './Instructions.svelte';
import ContentsDropdown from './Navigation.svelte';
import Output from './Output.svelte';
import { load as pyLoad } from './pyeval.mjs';
import { log, logEvent } from './telemetry.mjs';

export let page;
const savedText = getContext('savedText');

const question = {
	text_html: page.html ?? page.description.html,
	source: page.description.source,
	source_answer: page.answer
};

if (page.imports != null) pyLoad(page.imports);

let readyPython;
let editor;
let evalPython;
let editor_text = savedText[page.label] ?? question.source ?? "";
let isCorrect;
let hasAnswer = (question.source_answer != null);
let showUndo = false;
$: isCorrect = hasAnswer && textEqual(editor_text, question.source_answer);
$: isOriginal = textEqual(editor_text, question.source ?? "");


function textEqual(txt1, txt2) {
	return txt1.trim().replace(/\s+/gm, '') === txt2.trim().replace(/\s+/gm, '');
}

function reset() { 
	editor.update(question.source ?? ""); 
	showUndo = false;
}
function show_answer() { 
	showUndo = true;
	editor.update(question.source_answer ?? "");
	log({event:logEvent.ANSWER, label:page.label});
}
function undo() { 
	editor.undo();
	showUndo = false; 
}
function evaluate() { 
	if (evalPython == null) { console.log("Python not ready"); return; }
	evalPython(editor_text); 
	log({event:logEvent.EVALUATE, label:page.label, correct: isCorrect});
}

onMount(() => log({event:logEvent.OPEN, label:page.label}));
onDestroy(() => { savedText[page.label] = editor_text; });

</script>


<main class="tutorial-outer">
<div class="viewport">

<div class="instructions">
	<div class="table-of-contents">
		<ContentsDropdown selectedPage={page}/>
	</div>
	<Instructions 
		html={question.text_html} 
		next_href={page.next ? `#/${page.next.slug}` : null}
		/>
</div>

<div class="repl">
<SplitPane split="vertical" pos=0.6>

	<section slot=a class="inputpane">
	<div class="input">
		<CodeMirror bind:this={editor} on:execute={evaluate} bind:value={editor_text}/>
	</div>
	<div class="controls">
		<div>
		<button class="show" disabled={!readyPython} on:click={evaluate}>Evaluate</button>
		{#if readyPython}<button class="hint" on:click={evaluate}>Shift+Enter</button>{/if}
		</div>
		<div>
		{#if showUndo}<button class="hint" aria-label="Undo show answer" on:click={undo}><Icon data={undoIcon} size='1.5em' style="position:relative; top:0.45em;"/></button>{/if}
		<button class="show" disabled={isCorrect || !hasAnswer} on:click={show_answer}>Show me</button>
		<button class="show" disabled={isOriginal} on:click={reset}>Reset</button>
		</div>
	</div>
	</section>

	<section slot=b class="output">
	<Output bind:evaluate={evalPython} bind:ready={readyPython} />
	</section>

</SplitPane>
</div>

</div>
</main>


<style>


.tutorial-outer {
		height: calc(100vh - var(--navbar-height));
		position: relative;
		overflow: hidden;
		box-sizing: border-box;
		padding: 0;
	}

.viewport {
	display: grid;
	width: 100%;
	height: 100%;
	grid-template-columns: var(--sidebar-w) calc(100vw - var(--sidebar-w));
	grid-auto-rows: 100%;
}

.instructions {
	display: flex;
	flex-direction: column;
	height: 100%;
	border-right: 1px solid var(--second);
	background-color: var(--second);
	color: var(--sidebar-text);
}


.repl { 
	/*ddisplay: flex;
	dflex-direction: column;*/
	height: 100%;
	background-color: var(--back-api);
	overflow: hidden;
}

section {
	height: 100%;
}
section.inputpane {
	display: flex;
	flex-direction: column;
}

.input, .output {
	background-color: white;
	box-sizing: border-box;
}
.input {
	/*dflex: 1.618 10rem;*/
	border-bottom: solid white 1pt;
	flex-grow: 1;
	height: 0px;
}
.output {
	/*dflex: 1 8rem;*/
	padding-left: 1em;
	border: solid var(--second);
	border-width: 1px 0px 0px 0px;
	font-size: 1rem;
	overflow: auto;
	height: 100%;
}

.controls {
	height: fit-content;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	padding: .2rem 1rem;
}

.show {
	background-color: var(--prime);
	color: white;
	padding: .3em .7em;
	border-radius: var(--border-r);
	position: relative;
	margin: .3rem;
}

.show:hover {
	background-color:var(--flash);
}

.show:disabled {
	background-color: var(--back-api);
	color: var(--second);
}

.hint {
	background: none;
	border: 0;
	padding: 0;
	font-family: inherit;
	font-size: .8rem;
	color: var(--third);
	cursor: pointer;
}



</style>
